
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { AUDIO_TO_TEXT_PAGE } from '@/components/transcription-landing/landingPages';
import TranscriptionLanding from '@/components/transcription-landing/TranscriptionLanding';
export default function AudioToTextPage() {
    return <TranscriptionLanding page={AUDIO_TO_TEXT_PAGE}/>;
}

    async function __Next_Translate__getStaticProps__1a12e86ecdf__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-transcription/audio-to-text-converter',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a12e86ecdf__ as getStaticProps }
  